import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`;

export const HeaderText = styled.p`
    margin: 0;
    font-size: 0.875rem;
    color: ${colors.textSecondary};
    max-width: 520px;
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};

    @media (max-width: 700px) {
        flex-wrap: wrap;
        gap: 12px;
    }
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
`;

export const Name = styled.div`
    font-weight: 600;
    overflow-wrap: break-word;
`;

export const Meta = styled.div`
    font-size: 0.8125rem;
    color: ${colors.textSecondary};
`;

export const MissingMeta = styled.div`
    font-size: 0.8125rem;
    color: ${colors.danger};
`;

/*
* На узком экране действия ставим в столбик: в строку они съедали половину ширины,
* и название набора сжималось до пары букв.
* */
export const RowActions = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    @media (max-width: 700px) {
        flex-direction: column;
        /* Текстовая кнопка кита по высоте равна тексту — без зазора две подряд слипаются. */
        align-items: flex-end;
        gap: 8px;
    }
`;

export const Loading = styled.div`
    padding: 20px;
    text-align: center;
    font-size: 0.875rem;
    color: ${colors.textSecondary};
`;
